import { ShopifyBilling } from './Billing/ShopifyBilling';
import {
  ShopifyLogin,
  ShopifyLogout,
  ShopifyReset,
  ShopifySignUpForm,
} from './app';

export const shopifyRoutes = {
  login: {
    path: '/shopify-login',
    component: ShopifyLogin,
  },
  logout: {
    path: '/shopify-logout',
    component: ShopifyLogout,
  },
  reset: {
    path: '/reset',
    component: ShopifyReset,
  },
  signUpForm: {
    path: '/shopify-sign-up',
    component: ShopifySignUpForm,
  },
  billing: {
    path: '/billing',
    component: ShopifyBilling,
  },
};

export const shopifyRoutesPaths = Object.values(shopifyRoutes).map(v => v.path);
